import { UploadIssueReason } from "../lib/types/UploadIssueReason";
import { useUploadPreprocessor } from "../UploadPreprocessorContext";
import ModalTitle from "components/elements/Dialog/ModalTitle";
import MessageBanner, {
  MessageType,
} from "components/elements/MessageBanner/MessageBanner";

const UploadIssuesDialogTitle = () => {
  const { uploadIssues, missingFilesDetected } = useUploadPreprocessor();

  const singleIssueTitle =
    "There is an issue with the file that you're uploading.";
  const multipleIssuesTitle =
    "There are issues with multiple files that you're uploading.";
  const genericIssueTitle =
    uploadIssues.length > 1 ? multipleIssuesTitle : singleIssueTitle;

  return (
    <>
      <ModalTitle>
        {missingFilesDetected
          ? UploadIssueReason.MissingFile
          : genericIssueTitle}
      </ModalTitle>

      {missingFilesDetected && (
        <MessageBanner messageType={MessageType.Warning} colourWidth="lg">
          <div className="text-sm">
            <h3 className="mb-2 font-medium">Unable to begin upload</h3>
            <p className="font-light leading-5">
              One or more of your files are missing required contents. Please
              check your files, correct any issues and try again.
            </p>
          </div>
        </MessageBanner>
      )}
    </>
  );
};

export default UploadIssuesDialogTitle;
